//  ! 🔥 💪🏻 Bn Ramadan fullstack MERN project 2 ( E-commerce fullstack app )
//  ! " The end of this project is the completing of future successes and creativity , Just strive, be patient, commit and keep going. "
//  ! 🔥 💪🏻 Always forward ! 💪🏻 🔥
import React from 'react';
import CartItems from '../Components/CartItems/CartItems';

const Cart = () => {
  return (
    <div>
      <CartItems />
    </div>
  );
};

export default Cart;
